@let shiftColorOption = shiftColorOption$ | async;
@let hasProjectReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Project);
@if (shift) {
  <div>
    @let isLabel = shiftColorOption === ShiftColorOptions.Label && label;
    @let isProject =
      hasProjectReadPermission &&
      shiftColorOption === ShiftColorOptions.Project &&
      project;
    @let borderColor =
      isLabel
        ? label?.colorCode
        : isProject
          ? project?.colorCode
          : shiftCategoriesColorCode[shift.shiftCategoryId];
    @let presenceBorderColor = shift.id | shiftPresenceBorderColor | async;
    @let backgroundColor =
      isLabel
        ? (label?.colorCode | wilsonHexWithAlpha)
        : isProject
          ? (project?.colorCode | wilsonHexWithAlpha)
          : ShiftCardBackgroundColor[shift.shiftCategoryId];
    @let isNormalShift =
      shiftColorOption === ShiftColorOptions.ShiftCategory &&
      shift.shiftCategoryId === ShiftCategoriesIdsMap.Normal;
    @let isProjectOpen =
      hasProjectReadPermission && project?.status === ProjectStatus.OPEN;
    @let isShiftSelected =
      shiftMultiSelectHelperService.selectedShifts$
        | isShiftSelected: shift.id
        | async;
    @if (
      {
        left: (shiftStartTime | ganttStartingPixel | async),
        right: ([shiftStartTime, shiftEndTime] | ganttEndingPixel | async),
        staffLayoutStyle: staffLayoutStyle$ | async,
      };
      as data
    ) {
      <div
        class="shift"
        [class.group-item]="
          !isShiftSelected &&
          groupItemsSelectionHelperService.groupedShiftIds().has(shift.id)
        "
        [class.filtered]="!shift.isHighlighted"
        [style.left.px]="data.left"
        [style.right.px]="data.right"
        [style.height.px]="
          data.staffLayoutStyle === StaffLayoutStyle.Minimal
            ? MINIMAL_SHIFT_HEIGHT
            : COMPACT_SHIFT_HEIGHT
        "
        [class]="
          'timeline-shift-accent-border' +
          ' ' +
          'timeline-shift-type--' +
          shift.shiftCategoryId +
          ' ' +
          'timeline-shift-project--' +
          hasProjectReadPermission +
          '--' +
          project?.status
        "
        [ngStyle]="{
          'border-color':
            presenceBorderColor ?? (isProjectOpen ? borderColor : ''),
          'border-left-color':
            presenceBorderColor ??
            (isProjectOpen || !isNormalShift ? borderColor : ''),
          'border-width': presenceBorderColor ? '2px' : '',
          background: backgroundColor,
        }"
      >
        <div class="shift-details">
          <nz-skeleton
            [nzActive]="true"
            [nzParagraph]="{
              rows: data.staffLayoutStyle === StaffLayoutStyle.Minimal ? 1 : 2,
            }"
            [nzTitle]="false"
          ></nz-skeleton>
        </div>
      </div>
    }
  </div>
}
